import React from "react";
import {
  Control,
  FieldErrors,
  UseFormClearErrors,
  UseFormGetValues,
  UseFormReset,
  UseFormSetError,
  UseFormSetValue,
  UseFormTrigger,
  UseFormWatch,
} from "react-hook-form";

export interface ProductItem {
  productID: string;
  qty: number;
  [key: string]: any;
}

export interface EDBFormValues {
  _id: string | null;
  project: string | null;
  dockyard: string | null;
  company: string;
  dispositionAdress: string;
  dispositionAdress2: string;
  dispositionCity: string;
  dispositionCountry: string;
  dispositionPlace: string;
  dispositionDateIsExact: boolean;
  dispositionPostalCode: string;
  dispositionType: string;
  emailContactRecovery: string;
  entrepotName: string;
  firstnameContactRecovery: string;
  lastnameContactRecovery: string;
  phoneContactRecovery: string;
  preparationType: string;
  analyticCode: string;
  intervenantCompany: string | null;
  intervenantContact: string | null;
  integratedOrders: any | null;
  dispositionDate: string | null;
  scheduledInterventionDate: string | null;
  products: ProductItem[];
}

export interface EDBFormContextType {
  idEdb: string | null;
  currentEdb: any;
  control: Control<any>;
  setError: UseFormSetError<any>;
  setValue: UseFormSetValue<any>;
  getValues: UseFormGetValues<any>;
  reset: UseFormReset<any>;
  trigger: UseFormTrigger<any>;
  errors: FieldErrors<any>;
  watch: UseFormWatch<any>;
  clearErrors: UseFormClearErrors<any>;
  defaultValues: EDBFormValues;
  integratedOrders: any | null;
  isLoadingIntegratedOrders: boolean;
  projectOptions: any[];
  setProjectOptions: React.Dispatch<React.SetStateAction<any[]>>;
  dockyardOptions: any[];
  setDockyardOptions: React.Dispatch<React.SetStateAction<any[]>>;
  showCart: boolean;
  setShowCart: React.Dispatch<React.SetStateAction<boolean>>;
  step: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  maxStepIndex: number;
  changeStep: (stepNumber: number) => void;
  openDeleteEDBModal: boolean;
  setOpenDeleteEDBModal: React.Dispatch<React.SetStateAction<boolean>>;
  currentCompany: string | null;
  currentProject: string | null;
  currentDockyard: string | null;
  cart: ProductItem[];
  orderProducts: ProductItem[] | undefined;
  sidebarCompanyFilter: any;
  sourceDockyardCompany: { _id: string; name: string } | null;
}

export enum STEP {
  FIRST_STEP = 0,
  PRODUCT_STEP = 1,
  LAST_STEP = 2,
}

export const EDB_STEPS = [
  { step: STEP.FIRST_STEP, label: "Identification" },
  { step: STEP.PRODUCT_STEP, label: "Besoin matériel" },
  { step: STEP.LAST_STEP, label: "Préparation et livraison" },
];

export const edbStepLabels = EDB_STEPS.map((s) => s.label);
